module.exports = __webpack_public_path__ + "static/coffee-5d174c0bd18cca58ede8dbecf71fffa8.gif";